'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('jquery.cookie');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $Cookie = (0, _jquery2.default)('#CookiePolicy');
var $btn = $Cookie.find('button');

if (_jquery2.default.cookie('cookie_policy') == undefined) {
    $Cookie.show();
    $btn.on('click', function () {
        $Cookie.remove();
        _jquery2.default.cookie('cookie_policy', 'accept', { expires: 365 });
    });
}